<template>
    <modal :modal-id="modalId"
                     :title="modalTitle"
                     :preloader="preloader"
                     class="alert-modal"
                     @submit="submit"
                     @close-modal="closeModal">
        <template slot="body">
            <app-overlay-loader v-if="preloader"/>
            
            <div class="box text-center mt-5">                
                <h2>{{ $t('timeline_future_alert') }}</h2>
                <div class="form-group row align-items-center mb-5">
                       
                    
                </div>
                
            </div>
            
            
            
            
                    
            
            <div class="clearfix"></div>
            
        </template>
    </modal>
</template>

<script>
    import {FormMixin} from '../../../../../../core/mixins/form/FormMixin.js';
    import {ModalMixin} from "../../../../../Mixins/ModalMixin";
    import {UserMixin} from "../../../../../../app/Components/Views/Auth/Mixins/UserMixin";
    import AppLibrary from "../../../../../Helpers/AppLibrary";

    export default {
        name: "AlertModal",
        extends: AppLibrary,
        mixins: [FormMixin, ModalMixin, UserMixin],
        props: {
            tableId: String,
            selectedRows: Array,
            modalType: String,
        },
        data() {
            return {
                preloader: false,
                
                inputs: {
                    name: '',
                    email: '',
                    message: '',
                    gender: 'male',
                    residence: '1',
                    status: '2',
                    phone: ' ',
                    tag: [],
                    birthdate: new Date()
                },
                phone: '',
                statusLists: [
                    {id: '1', value: 1,},
                    {id: '2', value: 2,},
                    {id: '3', value: 3,},
                ],
                genderLists: [
                    {id: 'male', value: "Male"},
                    {id: 'female', value: "Female"},
                    {id: 'other', value: "Other"},
                ],
                ratingLists: [
                    {id: '0', value: "0"},
                    {id: '1', value: "1"},
                    {id: '2', value: "2"},
                    {id: '3', value: "3"},
                ],
                residenceLists: [
                    {id: '1', value: 'Hlavní město Praha'},
                    {id: '2', value: 'Středočeský kraj'},
                    {id: '3', value: 'Jihočeský kraj'},
                    {id: '4', value: 'Plzeňský kraj'},
                    {id: '5', value: 'Karlovarský kraj'},
                    {id: '6', value: 'Ústecký kraj'},
                    {id: '7', value: 'Liberecký kraj'},
                    {id: '8', value: 'Královéhradecký kraj'},
                    {id: '9', value: 'Pardubický kraj'},
                    {id: '10', value: 'Kraj Vysočina'},
                    {id: '11', value: 'Jihomoravský kraj'},
                    {id: '12', value: 'Olomoucký kraj'},
                    {id: '13', value: 'Zlínský kraj'},
                    {id: '14', value: 'Moravskoslezský kraj'},
                ],
                tableId: 'alert-Modal',
                modalId: 'alert-Modal',
                modalTitle: this.$t('add'),
                 
                
                
                value: {},
                tagPreloader: false,
                multiCreatePreloader: false,
                tags: [],
                skills: [],
                jobOptions: [],
                tagOptions: [],
                skillOptions: [],
            }
        },
        methods: {
            beforeSubmit() {
              this.preloader = true;
            },
            submit() {}
        }
    }
</script>
